// This is a duplication of the AppAlert modal but for non modal components.
// I didn't want this PR to be too big and I'm not sure how much we'll use this component so I'm leaving it here for now.
// If we want consistent look and behaviour we might want to refactor the AppAlert modal to use this component.

import React from 'react'
import { AlertColors, AlertIcon, VariantType } from '@/layouts/AppAlertProvider'
import { cn } from '../utilities'

interface Props {
  title: string | React.ReactNode
  text: string | React.ReactNode
  variant: VariantType
  children: React.ReactNode | undefined
  className?: string
}

function AppAlertButtonArea({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center justify-center w-full gap-2">
      {children}
    </div>
  )
}

function AppAlertComponent(props: Props) {
  const { text, title, variant, children, className } = props

  return (
    <div
      className={cn(
        `bg-white border border-grey-200 rounded-md overflow-hidden pb-6`,
        className
      )}
    >
      <div className="text-center ">
        {/* Banner */}
        <div className={cn(`w-full h-2 mb-6 ${AlertColors.bg[variant]}`)}></div>
        <div className="px-6">
          {/* Icon */}
          <div className="mb-6">
            <AlertIcon variant={variant} />
          </div>

          {/* Title */}
          <div
            className={cn(
              'text-lg font-semibold leading-6 text-gray-900 pt-2 '
            )}
          >
            {title}
          </div>

          {/* Message */}
          <p className="break-words text-center mx-auto pb-12 text-base  text-gray-600 pt-2">
            {text}
          </p>

          {/* Buttons */}
          <AppAlertButtonArea>{children}</AppAlertButtonArea>
        </div>
      </div>
    </div>
  )
}

export default AppAlertComponent
